const blobCloneMetadata = ({ file, newFile }) => {
    const { id, name, originalPosition, wasProcessedBefore } = file

    newFile.id = id
    newFile.name = name
    newFile.originalPosition = originalPosition
    newFile.noWatermark = Boolean(wasProcessedBefore)
    newFile.wasProcessedBefore = false
    newFile.isBlob = true

    return newFile
}

export default blobCloneMetadata